import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Clock, Shield, Truck } from 'lucide-react';
import Footer from './Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="logo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_5134e336-576d-4059-9f17-16d0386d12c4/artifacts/z406pozc_logo%20final.png" 
              alt="Laundry Ready Logo" 
              className="mx-auto"
            />
          </div>
          <h1 className="hero-title">Your Laundry, Our Priority</h1>
          <p className="hero-subtitle">
            Professional laundry services with convenient pickup and delivery. 
            Find trusted vendors, schedule services, and get your clothes cleaned with care.
          </p>
          <Link to="/vendors" className="btn-primary">
            Find Laundry Services
          </Link>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Why Choose Laundry Ready?</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <Clock />
              </div>
              <h3 className="service-title">Convenient Scheduling</h3>
              <p className="service-description">
                Book pickup and delivery at your preferred time slots. We work around your schedule.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <Shield />
              </div>
              <h3 className="service-title">Quality Guaranteed</h3>
              <p className="service-description">
                Professional cleaning with quality guarantees. Your clothes are in safe hands.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <Truck />
              </div>
              <h3 className="service-title">Pickup & Delivery</h3>
              <p className="service-description">
                Door-to-door service with reliable pickup and delivery by trusted drivers.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <Sparkles />
              </div>
              <h3 className="service-title">Premium Care</h3>
              <p className="service-description">
                Specialized treatments for different fabric types with eco-friendly detergents.
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <Link to="/vendors" className="btn-secondary">
              Get Started Today
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default HomePage;